import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-unfold-more",
  templateUrl: "./med-icon-unfold-more.component.html",
})
export class MedIconUnfoldMoreComponent extends SvgMixinComponent {}
